import { memo } from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import CircleIcon from '@mui/icons-material/Circle';
import type { StepperProps } from '@mui/material';

const useStyles = makeStyles({ name: 'SignupHeader' })((theme) => ({
  step: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),

    '&.MuiStep-alternativeLabel': {
      '& .MuiStepConnector-root': {
        top: '50%',
        transform: 'translateY(-50%)',
        left: 'calc(-50% + 7px)',
        right: 'calc(50% + 7px)',

        '& > .MuiStepConnector-line': {
          borderColor: theme.palette.primary.light,
        },
      },

      '& .MuiStepLabel-label': {
        display: 'none',
      },

      '& svg': {
        fontSize: 16,
      },

      '&:not(.Mui-completed)': {
        '& .Mui-active > svg': {
          color: `${theme.palette.primary.main} !important`,
        },

        '& :not(.Mui-active) > svg': {
          color: `${theme.palette.primary.light} !important`,
        },
      },

      '&.Mui-completed': {
        '& svg': {
          color: `${theme.palette.primary.dark} !important`,
        },
      },
    },
  },
}));

interface StepsProps {
  readonly steps: number;
  readonly currentStep: number;
}

const IconComponent = () => <CircleIcon />;

export const Steps = memo<StepsProps & StepperProps>(({ steps, currentStep, ...StepperProps }) => {
  const { classes } = useStyles();

  return (
    <Stepper
      alternativeLabel
      nonLinear
      activeStep={currentStep - 1}
      {...StepperProps}
    >
      {Array.from(Array(steps)).map((_, index) => {
        const step = index;

        return (
          <Step
            key={step}
            completed={step < currentStep - 1}
            className={classes.step}
          >
            <StepLabel
              StepIconComponent={IconComponent}
            >
              Step
              {' '}

              {step + 1}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
});
